/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * MCP feature payload.
 */
export type HookMCPData = {
  /**
   * MCP server command, when available.
   */
  command?: string | undefined;
  /**
   * JSON-encoded MCP tool result, when reported as a string.
   */
  resultJson?: string | undefined;
  /**
   * Stable server identity inferred by the hook adapter.
   */
  serverIdentity?: string | undefined;
  /**
   * Provider-reported MCP server name.
   */
  serverName?: string | undefined;
  /**
   * MCP server URL, when available.
   */
  url?: string | undefined;
};

/** @internal */
export type HookMCPData$Outbound = {
  command?: string | undefined;
  result_json?: string | undefined;
  server_identity?: string | undefined;
  server_name?: string | undefined;
  url?: string | undefined;
};

/** @internal */
export const HookMCPData$outboundSchema: z.ZodMiniType<
  HookMCPData$Outbound,
  HookMCPData
> = z.pipe(
  z.object({
    command: z.optional(z.string()),
    resultJson: z.optional(z.string()),
    serverIdentity: z.optional(z.string()),
    serverName: z.optional(z.string()),
    url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      resultJson: "result_json",
      serverIdentity: "server_identity",
      serverName: "server_name",
    });
  }),
);

export function hookMCPDataToJSON(hookMCPData: HookMCPData): string {
  return JSON.stringify(HookMCPData$outboundSchema.parse(hookMCPData));
}
